import instanceAxios from '@/util/axios';
import { GetInstitutionsPublicRequest, GetInstitutionsPublicResponse } from './getInstitutionsPublic.types';
import { institutionsAllPubUrl } from '@/constants';

export async function getInstitutionsPublic(
  request?: GetInstitutionsPublicRequest
): Promise<GetInstitutionsPublicResponse> {
  const response = await instanceAxios.get<GetInstitutionsPublicResponse>(institutionsAllPubUrl, { params: request });
  return response.data;
}
